<template>
  <transition name="modal" mode="out-in">
    <div class="modal-wrapper">
      <div class="overlay" @click="close"></div>
      <div class="modal_container">
        <div class="modal_contents">
          <iframe class="video" :src="'https://www.youtube.com/embed/' + cardData.trans.url + '?/controls=0&rel=0&autoplay=1&loop=1'" loop="1" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture;loop;" allowfullscreen></iframe>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
  export default {
    props:["cardData"],
    data(){
      return{
        window_w:0,
      }
    },
    methods: {
      close() {
        this.$emit('closeZoom')
      },
    },
    mounted(){
      
    },
    computed:{
    }
  }
</script>

<style lang="scss">
  .modal-slide{
    margin-top: 65px;
    margin-bottom: 0;
    padding: 0 90px;
    position: relative;
    @media screen and (max-width: 992px){
      margin-top: 40px;
      padding: 0 60px;
    }
  }
</style>
<style lang="scss" scoped>
  .product-info{
    padding: 0 90px;
    max-height: calc(100vh - 180px);
    overflow: auto;
    -ms-overflow-style: none;
    overflow: -moz-scrollbars-none;
    &::-webkit-scrollbar{
      display: none;
    }
    @media screen and (max-width: 992px){
      padding: 0 60px;
    }
    @media screen and (max-width: 576px){
      padding: 0 30px;
    }
    .product-first-img{
      .mainImg[lazy=loading]{
        background-size: auto;
      }
      .mainImg{
        width: 100%;
        padding-top: 100%;
        background-repeat: no-repeat;
        background-position: center;
        background-size: contain;
      }
    }
    .product-detail{
      text-align:left;
      color: black;
      padding: 45px 0 0 0;
      height: 324px;
      overflow: auto;
      -ms-overflow-style: none;
      overflow: -moz-scrollbars-none;
      &::-webkit-scrollbar{
        display: none;
      }
      @media screen and (max-width: 1200px){
        height: 240px;
      }
      @media screen and (max-width: 992px){
        padding: 0;
        height: auto;
      }
      .product-name{
        font-size:20px;
        margin-bottom: 26px;
        line-height: 30px;
      }
      .product-intro{
        font-family: 'Noto Sans TC', Arial, sans-serif;
        font-size:16px;
        margin-bottom: 0;
        white-space: pre-wrap;
        word-wrap: break-word;
        word-break: break-all;
      }
    }
  }
  
  .modal-wrapper{
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100vh;
    z-index: 99999;
    .overlay {
      position: absolute;
      background: rgba(0,0,0,.8);
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      transition: opacity 0.4s ease;
    }
    .modal_container{
      width: 100%;
      height: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
      .modal_contents {
        position: relative;
        width: 100%;
        max-width: 1000px;
        max-height: calc(100vh - 60px);
        margin: 0 auto;
        padding:10px;
        background-color:white;
        box-shadow: 0 10px 20px rgba(0,0,0,0.19), 0 6px 6px rgba(0,0,0,0.23);
        transition: all 0.4s ease;
        @media screen and (max-width: 1200px){
          max-width: 800px;
        }
        @media screen and (max-width: 992px){
          max-width: calc(100% - 60px);
        }
        .video{
          width: 100%;
          height: 60vh;
        }
      }
    }
  }

  .modal-enter,
  .modal-leave-active{
    opacity: 0;
  }

  .modal-enter .modal_contents,
  .modal-leave-active .modal_contents {
    -webkit-transform: scale(1.1);
    transform: scale(1.1);
  }
</style>


// WEBPACK FOOTER //
// src/components/VideoModal.vue